common.View.create('galaxy::habitats.website.partials.header.Events', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initIntroductionButton();
    },

    initIntroductionButton() {
        this.element.find('#highlight-video').on('click', (event) => {
            this.element.find('.wistia_embed img').trigger('click');
        });
    },

});